import { IWorksheetComponent } from '../../Core/types';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { Button } from 'Components/Core';
import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { ManageLoadIncrementsDialog } from './ManageLoadIncrementsDialog';
import { useState } from 'react';

let ManageLoadIncrementsSectionBase: React.FC<IWorksheetComponent> = () => {
  const [showManageLoadIncrementsDialog, setShowManageLoadIncrementsDialog] = useState(false);

  return (
    <ListFieldSection>
      <div>
        <Button onClick={() => setShowManageLoadIncrementsDialog(true)}>Manage Load Increments</Button>
      </div>
      <NamePrefixModifier namePrefix="data">
        <ManageLoadIncrementsDialog
          visible={showManageLoadIncrementsDialog}
          onClose={() => setShowManageLoadIncrementsDialog(false)}
        />
      </NamePrefixModifier>
    </ListFieldSection>
  );
};

const ManageLoadIncrementsSection = withInjectedProps(ManageLoadIncrementsSectionBase);
export { ManageLoadIncrementsSection };
export default ManageLoadIncrementsSection;
